/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Vietnamese (Vietnam)
export default {
  'feedback-collector.anonymous': 'Phản hồi này đang được gửi ẩn danh. Atlassian sẽ không thể liên hệ trực tiếp với bạn về phản hồi này',
  'feedback-collector.anonymous.title': 'Phản hồi ẩn danh',
  'feedback-collector.can-be-contacted.label': 'Có, đội ngũ Atlassian có thể liên hệ với tôi để tìm hiểu thêm về trải nghiệm của tôi nhằm cải thiện các sản phẩm và dịch vụ của Atlassian. Tôi công nhận <a>Chính sách Quyền riêng tư của Atlassian</a>.',
  'feedback-collector.cancel-button.label': 'Hủy',
  'feedback-collector.default.custom.textarea.label': 'Bạn đang nghĩ gì?',
  'feedback-collector.enrol-in-research.label': 'Tôi muốn tham gia vào việc tìm kiếm sản phẩm',
  'feedback-collector.feedback-title': 'Chia sẻ suy nghĩ của bạn',
  'feedback-collector.form.bug.label': 'Mô tả lỗi hoặc vấn đề',
  'feedback-collector.form.comment.label': 'Hãy cho chúng tôi biết suy nghĩ của bạn',
  'feedback-collector.form.empty.label': 'Hãy chọn một tùy chọn',
  'feedback-collector.form.question.label': 'Những điều bạn muốn biết',
  'feedback-collector.form.suggestion.label': 'Hãy cho chúng tôi biết bạn muốn cải tiến điều gì',
  'feedback-collector.option.bug.label': 'Báo cáo lỗi',
  'feedback-collector.option.comment.label': 'Để lại nhận xét',
  'feedback-collector.option.default.label': 'Chọn ý kiến phản hồi',
  'feedback-collector.option.default.placeholder': 'Chọn một ý kiến phản hồi',
  'feedback-collector.option.question.label': 'Đặt câu hỏi',
  'feedback-collector.option.suggestion.label': 'Đề xuất cải tiến',
  'feedback-collector.required.fields.summary': 'Các trường bắt buộc được đánh dấu bằng dấu sao',
  'feedback-collector.submit-button.label': 'Gửi phản hồi',
  'feedback-collector.success-flag.description': 'Ý kiến phản hồi quý báu của bạn giúp chúng tôi liên tục cải tiến sản phẩm.',
  'feedback-collector.success-flag.title': 'Cảm ơn bạn!',
  'feedback-collector.summary-placeholder': 'Hãy cho chúng tôi biết suy nghĩ của bạn',
  'proforma-form-builder.feedback-icon-label': 'Phản hồi',
  'proforma-form-builder.give-feedback': 'Đưa ra phản hồi'
};